import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { BRAND_CEL } from 'contexts/CruiseSearchContext/constants';
import { getOfferInfo } from 'lib/targetedOffers/Offers';
import PropTypes from 'prop-types';
import { useContext } from 'react';

import { IconPriceCel, IconPriceRCI } from 'components/svg';
import { Applied, Card, Content, Description, Expires, IconContainer, Perks, TermsAndConditions } from './MyOffersCard.styled';

const MyOffersCard = ({ targetedOffer, active, applied, disabled, onClick }) => {
	const { globalization, brand } = useContext(CruiseSearchContext);

	const { title, perksInfo, couponCode, defaultEndDate, link, isExpireToday, isExpireSoon } = getOfferInfo(targetedOffer);

	const { filtersDictionary } = globalization?.dictionaries || {};
	const {
		labelTargetedOffersExpiresToday,
		labelTargetedOffersExpiresSoon,
		labelTargetedOffersIncompatible,
		labelTargetedOffersCurrentyApplied,
		actionTargetedOffersCurrentyTermsConditions,
		labelTargetedOffersCurrentyOfferExpiresOn,
		labelTargetedOffersWithPromoCode,
	} = filtersDictionary;

	const { generalDescriptionSeparator: perkTexts } = perksInfo;

	const validateExpires = isExpireToday || isExpireSoon;

	const getQualifier = () => {
		if (applied) return labelTargetedOffersCurrentyApplied;
		if (disabled) return labelTargetedOffersIncompatible;
		if (isExpireSoon) return labelTargetedOffersExpiresSoon;
		if (isExpireToday) return labelTargetedOffersExpiresToday;
	};

	const qualifier = getQualifier();

	return (
		<Card onClick={onClick} disabled={disabled} active={active} applied={applied}>
			<IconContainer>{brand === BRAND_CEL.code ? <IconPriceCel /> : <IconPriceRCI />}</IconContainer>
			<Content>
				{qualifier && <Applied>{qualifier}</Applied>}
				<Description>{title}</Description>
				<Perks>
					{perkTexts}{' '}
					{couponCode && (
						<>
							{labelTargetedOffersWithPromoCode}:&nbsp;
							<strong>{couponCode}</strong>
						</>
					)}
				</Perks>
				<Expires alert={validateExpires}>
					{labelTargetedOffersCurrentyOfferExpiresOn}&nbsp;{defaultEndDate}.
				</Expires>
				<TermsAndConditions href={link} target="_blank">
					{actionTargetedOffersCurrentyTermsConditions}
				</TermsAndConditions>
			</Content>
		</Card>
	);
};

MyOffersCard.propTypes = {
	active: PropTypes.bool,
	applied: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	targetedOffer: PropTypes.shape({
		title: PropTypes.string,
		perks: PropTypes.array,
		endDate: PropTypes.string,
		couponCode: PropTypes.string,
		termsAndConditions: PropTypes.shape({
			link: PropTypes.string,
		}),
	}),
};

export default MyOffersCard;
